import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PURGE } from "redux-persist";
import apiInstance from '../../../../api';
import ym from 'react-yandex-metrika';

export const getSteps = createAsyncThunk(
  'kitchen/getSteps',
  async (data, { rejectWithValue }) => {
    const api = '/kitchens/stepsStartKitchen/getByKitchenId?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data.stepsStartKitchen;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const updateSteps = createAsyncThunk(
  'kitchen/updateSteps',
  async (data, { rejectWithValue }) => {
    const api = '/kitchens/stepsStartKitchen/update?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const sendRequestKitchens = createAsyncThunk(
  'kitchen/sendRequestKitchens',
  async (data, { rejectWithValue }) => {
    const api = '/kitchens/getAvailableKitchens?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch kitchens');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const sendRequestUserKitchenCreate = createAsyncThunk(
  'kitchen/sendRequestUserKitchenCreate',
  async (data, { rejectWithValue }) => {
    const api = '/kitchens/userKitchenCreation?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        ym('reachGoal','new_kitchen_create');
        return response.data.data;
      } else {
        return rejectWithValue('Failed to create user kitchen');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

export const sendRequestCategoriesCatalogGet = createAsyncThunk(
  'kitchen/sendRequestCategoriesCatalogGet',
  async (data, { rejectWithValue }) => {
    const api = '/categories/get?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data.categories;
      } else {
        return rejectWithValue('Failed to fetch categories catalog');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

const getInitialSelectedKitchen = () => {
  const sessionSelected = sessionStorage.getItem('selectedKitchen');
  if (sessionSelected) {
    try {
      return JSON.parse(sessionSelected);
    } catch (error) {
      console.error('Ошибка парсинга sessionStorage selectedKitchen:', error);
    }
  }

  return null;
};

const initialState = {
  //Kitchen
  kitchensRequestStatus: null,
  kitchens: [],
  stepsGetRequestStatus: null,
  stepsUpdateRequestStatus: null,
  isKitchenOwner: false,
  totalKitchens: 0,
  currentPage: 1,
  selectKitchen: getInitialSelectedKitchen(),

  //UserKitchenCreate
  userKitchenCreateRequestStatus: null,

  //CategoriesCatalog
  categoriesCatalogGetRequestStatus: null,
  categoriesCatalog: [],
};

const persistSelectedKitchen = (kitchen) => {
  if (!kitchen) {
    return;
  }
  const serialized = JSON.stringify(kitchen);
  sessionStorage.setItem('selectedKitchen', serialized);
  localStorage.setItem('lastSelectedKitchen', serialized);
};

const isInheritancePending = () => sessionStorage.getItem('inheritKitchenPending') === '1';

const kitchenSlice = createSlice({
  name: 'kitchen',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getSteps.pending, (state) => {
        state.stepsGetRequestStatus = 'pending';
      })
      .addCase(getSteps.fulfilled, (state, action) => {
        state.stepsGetRequestStatus = 'resolved';
        state.selectKitchen = { ...state.selectKitchen, stepsStartKitchen: action.payload };
      })
      .addCase(getSteps.rejected, (state) => {
        state.stepsGetRequestStatus = 'rejected';
      })
      .addCase(updateSteps.pending, (state) => {
        state.stepsUpdateRequestStatus = 'pending';
      })
      .addCase(updateSteps.fulfilled, (state) => {
        state.stepsUpdateRequestStatus = 'resolved';
      })
      .addCase(updateSteps.rejected, (state) => {
        state.stepsUpdateRequestStatus = 'rejected';
      })
      .addCase(sendRequestKitchens.pending, (state) => {
        state.kitchensRequestStatus = 'pending';
      })
      .addCase(sendRequestKitchens.fulfilled, (state, action) => {
        state.kitchensRequestStatus = 'resolved';
        const data = action.payload;
        state.kitchens = data.kitchens;
        state.totalKitchens = data.countkitchens;
        state.isKitchenOwner = data.isKitchenOwner;

        if (data.kitchens.length >= 1) {
          if (state.selectKitchen !== null) {
            const matchKitchen = data.kitchens.find(kitchen => kitchen?.id === state.selectKitchen?.id);

            if (matchKitchen) {
              state.selectKitchen = matchKitchen;
              persistSelectedKitchen(matchKitchen);
            } else {
              state.selectKitchen = data.kitchens[0];
              persistSelectedKitchen(data.kitchens[0]);
            }
          } else if (!isInheritancePending()) {
            state.selectKitchen = data.kitchens[0];
            persistSelectedKitchen(data.kitchens[0]);
          }
        }

        // Обновляем selectKitchen
        if (state.selectKitchen !== null) {
          const selectedKitchen = data.kitchens.find(kitchen => kitchen.id === state.selectKitchen.id);
          if (selectedKitchen) {
            state.selectKitchen = selectedKitchen;
            persistSelectedKitchen(selectedKitchen);
          }
        }
      })
      .addCase(sendRequestKitchens.rejected, (state) => {
        state.kitchensRequestStatus = 'rejected';
      })
      .addCase(sendRequestUserKitchenCreate.pending, (state) => {
        state.userKitchenCreateRequestStatus = 'pending';
      })
      .addCase(sendRequestUserKitchenCreate.fulfilled, (state) => {
        state.userKitchenCreateRequestStatus = 'resolved';
      })
      .addCase(sendRequestUserKitchenCreate.rejected, (state) => {
        state.userKitchenCreateRequestStatus = 'rejected';
      })
      .addCase(sendRequestCategoriesCatalogGet.pending, (state) => {
        state.categoriesCatalogGetRequestStatus = 'pending';
      })
      .addCase(sendRequestCategoriesCatalogGet.fulfilled, (state, action) => {
        state.categoriesCatalogGetRequestStatus = 'resolved';
        state.categoriesCatalog = action.payload;
      })
      .addCase(sendRequestCategoriesCatalogGet.rejected, (state) => {
        state.categoriesCatalogGetRequestStatus = 'rejected';
      })
      .addCase(PURGE, () => {
        return initialState;
      });
  },
  reducers: {
    //Kitchen
    clearKitchensStatus: (state) => { state.kitchensRequestStatus = null; },
    setKitchensData: (state, action) => {
      const data = action.payload;
      state.kitchens = data.kitchens;
      state.totalKitchens = data.countkitchens;
      state.isKitchenOwner = data.isKitchenOwner;

      if (data.kitchens.length >= 1) {
        if (state.selectKitchen !== null) {
          const matchKitchen = data.kitchens.find(kitchen => kitchen?.id === state.selectKitchen?.id);

          if (matchKitchen) {
            state.selectKitchen = matchKitchen;
            persistSelectedKitchen(matchKitchen);
          } else {
            state.selectKitchen = data.kitchens[0];
            persistSelectedKitchen(data.kitchens[0]);
          }
        } else if (!isInheritancePending()) {
          state.selectKitchen = data.kitchens[0];
          persistSelectedKitchen(data.kitchens[0]);
        }
      }
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setSelectKitchen: (state, action) => {
      state.selectKitchen = action.payload;
      persistSelectedKitchen(action.payload);
      state.menuAllProductsData = [];
      state.selectedMenuDate = null;
      state.selectedMenuRace = null;
    },
    updateSelectKitchen: (state, action) => {
      const kitchens = action.payload;
      
      if (state.selectKitchen !== null) {
        const selectedKitchen = kitchens.find(kitchen => kitchen.id === state.selectKitchen.id);
        state.selectKitchen = selectedKitchen;
        persistSelectedKitchen(selectedKitchen);
      } else {
        return;
      }
    },
  },
});

export const {
  //Kitchen
  clearKitchensStatus,
  setKitchensData,
  setCurrentPage,
  setSelectKitchen,
  updateSelectKitchen,
} = kitchenSlice.actions;

export default kitchenSlice.reducer;
